document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".vj-card");
  const grid = document.querySelector(".vj-grid");

  // 表示アニメーション：IntersectionObserver
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  cards.forEach((card, index) => {
    // 遅延アニメーション設定（1枚ずつフェードイン）
    card.style.transitionDelay = `${index * 100}ms`;

    // IntersectionObserverに登録
    observer.observe(card);

    // hover イベント処理
    card.addEventListener("mouseenter", () => {
      grid.classList.add("hovering");
      card.classList.add("hovered");
    });

    card.addEventListener("mouseleave", () => {
      grid.classList.remove("hovering");
      card.classList.remove("hovered");
    });
  });
});
